import { t, Trans } from "@lingui/macro";
import { Stack } from "@mui/material";
import React from "react";

import { CheckboxGroupField, DropdownField, InputField } from "@/components/shared/fields";
import { AttributeFragment, AttributeInputTypeEnum } from "@/saleor/api";

import PersonalizeInfoPopover from "./PersonalizeInfoPopover";

interface PersonaliseFieldProps {
	attribute: AttributeFragment;
	name: string;
}

const PersonaliseField: React.VFC<PersonaliseFieldProps> = ({ attribute, name }) => {
	switch (attribute.inputType) {
		case AttributeInputTypeEnum.RichText:
			return (
				<InputField
					label={attribute.name || ""}
					name={name}
					helpText={
						<Stack direction="row" alignItems="center">
							<div>
								<Trans>e.g. Happy birthday!</Trans> &#123;&#123; full_name
								&#125;&#125;
							</div>
							<PersonalizeInfoPopover />
						</Stack>
					}
				/>
			);
		case AttributeInputTypeEnum.Dropdown: {
			const dropdownValues =
				attribute.choices?.edges?.map(({ node }) => ({
					label: node.name || "",
					value: node.name || node.id,
				})) || [];
			return (
				<DropdownField
					label={attribute.name || ""}
					data={dropdownValues}
					name={name}
					defaultText={t`Select...`}
				/>
			);
		}
		case AttributeInputTypeEnum.Numeric:
			return <InputField label={attribute.name || ""} name={name} type="number" />;
		case AttributeInputTypeEnum.Boolean:
			return (
				<CheckboxGroupField
					label={attribute.name || ""}
					name={name}
					data={{ value: "" }}
					direction="row"
				/>
			);
	}
	return null;
};

export default PersonaliseField;
